import { SelectItemOptions } from '@usitsdasdesign/dds-ng/select';
import { Size, Themes } from '@usitsdasdesign/dds-ng/shared';
import { SortOrder } from '../../../../../models/common.enums';
import { DashboardSorting } from '../../../../../models/dashboard-common.model';
import { TeamRequest } from '../../../../../models/find-a-space.model';
import { SelectedGroupMultiselectItem } from '../../../../../shared/components/group-multiselect-dropdown/group-multiselect-dropdown.component';
import { SelectedOwnerItem } from '../../../../../shared/components/owner-search/owner-search.component';
import { ButtonKind,ButtonOptions } from 'src/app/shared/components/button/button.component';

export interface DashboardFormValue {
  dates: Date[];
  assignedToMe: boolean;
  searchText: string;
  locations: SelectedGroupMultiselectItem[];
  spaceTypes: number[];
  meetingTypes: number[];
  statuses: string[];
  serviceOrders: number[];
  sortings: DashboardSorting[];
  bookingSpecialists: SelectedOwnerItem[];
  meetingSpecialists: SelectedOwnerItem[];
  bookingSpecialistNotAssigned: boolean;
  meetingSpecialistNotAssigned: boolean;
  classifications: string[];
  teamRequestIds: TeamRequest[];
}
export enum BookingDashboardSorting {
  SpaceBookingName = 'SpaceBookingName',
  SpaceBookingId = 'SpaceBookingId',
  ReservationId = 'ReservationId',
  StartDate = 'StartDate',
  EndDate = 'EndDate',
  Space = 'Space',
  Floor = 'Floor',
  Building = 'Building',
  SpaceType = 'SpaceType',
  EventType = 'EventType',
  EventStatus = 'EventStatus',
  PointOfContactFirstName = 'PointOfContactFirstName',
  PointOfContactLastName = 'PointOfContactLastName',
  SpaceBookingSpecialistFirstName = 'SpaceBookingSpecialistFirstName',
  SpaceBookingSpecialistLastName = 'SpaceBookingSpecialistLastName',
  ReservationSpecialistFirstName = 'ReservationSpecialistFirstName',
  ReservationSpecialistLastName = 'ReservationSpecialistLastName',
}

export let ORDERS: SelectItemOptions[] = [
  {
    heading: 'Translation.Ascending',
    value: SortOrder.Asc,
  },
  {
    heading: 'Translation.Descending',
    value: SortOrder.Desc,
  },
];

export let OrderAlphabetic: SelectItemOptions[] = [
  {
    heading: 'Translation.A to Z',
    value: SortOrder.Asc,
  },
  {
    heading: 'Translation.Z to A',
    value: SortOrder.Desc,
  },
];

export let OrderDate: SelectItemOptions[] = [
  {
    heading: 'Translation.Latest_first',
    value: SortOrder.Desc,
  },
  {
    heading: 'Translation.Earliest_first',
    value: SortOrder.Asc,
  },
];

export let SORTINGS: (SelectItemOptions & { sortOption: SelectItemOptions[] })[] = [
  {
    heading: 'Translation.Bookingname',
    value: BookingDashboardSorting.SpaceBookingName,
    sortOption: OrderAlphabetic,
  },
  {
    heading: 'Translation.Date_time',
    value: BookingDashboardSorting.StartDate,
    sortOption: OrderDate,
  },
  {
    heading: 'Translation.Pointofcontact',
    value: BookingDashboardSorting.PointOfContactFirstName,
    sortOption: OrderAlphabetic,
  },
  {
    heading: 'Translation.Location',
    value: BookingDashboardSorting.Building,
    sortOption: OrderAlphabetic,
  },
  {
    heading: 'Translation.Floor',
    value: BookingDashboardSorting.Floor,
    sortOption: ORDERS,
  },
  {
    heading: 'Translation.Type',
    value: BookingDashboardSorting.SpaceType,
    sortOption: OrderAlphabetic,
  },
  {
    heading: 'Translation.Meetingtype',
    value: BookingDashboardSorting.EventType,
    sortOption: OrderAlphabetic,
  },
  {
    heading: 'Translation.Bookingspecialist',
    value: BookingDashboardSorting.SpaceBookingSpecialistFirstName,
    sortOption: OrderAlphabetic,
  },
  {
    heading: 'Translation.Meetingspecialist',
    value: BookingDashboardSorting.ReservationSpecialistFirstName,
    sortOption: OrderAlphabetic,
  },
  {
    heading: 'Translation.Bookingstatus',
    value: BookingDashboardSorting.EventStatus,
    sortOption: OrderAlphabetic,
  },
];

export const SECONDARY_BUTTON_OPTIONS: ButtonOptions = {
  kind: ButtonKind.secondary,
 };
export const PRIMARY_BUTTON_OPTIONS: ButtonOptions = {
  kind: ButtonKind.primaryLoud,
};
export interface BookingsDashboardPreferenceData {
  location?: SelectedGroupMultiselectItem[];
  serviceOrders?: number[];
  spaceTypes?: number[];
  meetingTypes?: number[];
  status?: string[];
  id?: string;
  form?: DashboardFormValue;
  assignedToMe?: boolean;
}
